import ListItemButton from '@mui/material/ListItemButton'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useGoToHook } from 'services/router/useGoTo.hook'
import { useAppState } from 'state/store'
import { Colors } from 'theme/colors'
import { theme } from 'theme/theme'

const useClasses = makeStyles({
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: Colors.neutrals[8],
    '& p': {
      fontSize: theme.typography.fontSize - 3,
    },
    '& svg': {
      height: 25,
      width: 25,
      color: Colors.neutrals[8],
    },
  },
})

export const DrawerListItem: React.FC<{
  route: string
  children?: React.ReactNode
}> = props => {
  const classes = useClasses()
  const goTo = useGoToHook()
  const path = useAppState(s => s.location.pathname)

  return (
    <ListItemButton
      style={props.route === path ? { backgroundColor: Colors.primary[2] } : {}}
      className={classes.listItem}
      onClick={() => goTo(props.route)}
    >
      <div className={classes.listItem}>{props.children}</div>
    </ListItemButton>
  )
}
